<div class="table-wrapper">
  <table mat-table [dataSource]="enrollmentsDataSource" class="mat-elevation-z8" *ngIf="enrollmentsDataSource?.data?.length > 0; else noData">

    <ng-container matColumnDef="rae">
      <th mat-header-cell *matHeaderCellDef> DCO </th>
      <td mat-cell *matCellDef="let enrollment"> {{ enrollment.rae }} </td>
    </ng-container>

    <ng-container matColumnDef="cco">
      <th mat-header-cell *matHeaderCellDef> CCO </th>
      <td mat-cell *matCellDef="let enrollment"> {{ enrollment.cco }} </td>
    </ng-container>

    <ng-container matColumnDef="enrollStatus">
      <th mat-header-cell *matHeaderCellDef> Enroll Status </th>
      <td mat-cell *matCellDef="let enrollment"> {{ enrollment.enrollStatus }} </td>
    </ng-container>

    <ng-container matColumnDef="effectiveDate">
      <th mat-header-cell *matHeaderCellDef> Effective Date </th>
      <td mat-cell *matCellDef="let enrollment"> {{ enrollment.effectiveDate | date }} </td>
    </ng-container>

    <ng-container matColumnDef="termDate">
      <th mat-header-cell *matHeaderCellDef> Term Date </th>
      <td mat-cell *matCellDef="let enrollment"> {{ enrollment.terminationDate | date }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns;">
    </tr>


  </table>

  <!-- No Records Template -->
  <ng-template #noData>
    <div class="no-data-message">
      <h4>No records to show</h4>
      <p>There are currently no records of enrollment.</p>
    </div>
  </ng-template>

</div>

